import { render } from "./StatsPage.vue?vue&type=template&id=f41c9bc8&scoped=true"
import script from "./StatsPage.vue?vue&type=script&lang=js"
export * from "./StatsPage.vue?vue&type=script&lang=js"

import "./StatsPage.vue?vue&type=style&index=0&id=f41c9bc8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f41c9bc8"]])

export default __exports__